import { motion, type MotionValue, type Transition } from 'framer-motion'

export const NOTCH_FILLET_SIZE = 6

const notchFilletTransition: Transition = { duration: 0.2, ease: 'easeOut' }

interface NotchFilletProps {
  isVisible: boolean
  side: 'left' | 'right'
  x: MotionValue<number>
}

/** Concave corner that blends the cutout's top edge into the screen edge. */
export function NotchFillet({ isVisible, side, x }: NotchFilletProps) {
  const cutoutOrigin = side === 'left' ? '0 100%' : '100% 100%'

  return (
    <motion.div
      aria-hidden
      className="pointer-events-none absolute left-0 top-0"
      style={{
        x,
        width: NOTCH_FILLET_SIZE,
        height: NOTCH_FILLET_SIZE,
        background: `radial-gradient(circle at ${cutoutOrigin}, transparent ${NOTCH_FILLET_SIZE - 0.5}px, #000 ${NOTCH_FILLET_SIZE}px)`,
      }}
      initial={false}
      animate={{ opacity: isVisible ? 1 : 0 }}
      transition={notchFilletTransition}
    />
  )
}
